import { string } from "../utils";
class OnlyInteger {
    validate(data) {
        if (data === 0) {
            return { isValid: true };
        }
        return {
            isValid: !string.isFalsy(data) && Number.isInteger(Number(data))
        };
    }
}
export default OnlyInteger;
